import { render, staticRenderFns } from "./BatchWash.vue?vue&type=template&id=23441884&scoped=true"
import script from "./BatchWash.vue?vue&type=script&lang=js"
export * from "./BatchWash.vue?vue&type=script&lang=js"
import style0 from "./BatchWash.vue?vue&type=style&index=0&id=23441884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23441884",
  null
  
)

export default component.exports